module.exports = __webpack_public_path__ + "img/ck.5389188d.svg";